export default __webpack_public_path__ + "static/media/push4.6eb74716.gif";